"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantEnum = void 0;
var TenantEnum;
(function (TenantEnum) {
    TenantEnum["JS_DE"] = "JS_DE";
    TenantEnum["JS_NOW_DE"] = "JS_NOW_DE";
    TenantEnum["JS_AT"] = "JS_AT";
    TenantEnum["JS_TEST"] = "JS_TEST";
    TenantEnum["MD_DE"] = "MD_DE";
    TenantEnum["MD_AT"] = "MD_AT";
    TenantEnum["MD_CH"] = "MD_CH";
    TenantEnum["MD_TEST"] = "MD_TEST";
})(TenantEnum || (exports.TenantEnum = TenantEnum = {}));
//# sourceMappingURL=TenantEnum.js.map